<script setup>
import { frames } from '../../../../utils/frames'
const gsapTimeline = useGsapTimeline()

defineProps({
  text: String,
})

const emit = defineEmits(['timeline', 'timelineOut'])

const pillElement = ref(null)

onMounted(() => {
  const timeline = gsapTimeline({ name: 'SlidingPill' })
    .startInvisible(pillElement)
    .from(pillElement, { width: 0, duration: frames(18, 50), ease: 'power3.out' }, '<')

  emit('timeline', timeline)

  const timelineOut = () => gsapTimeline({ name: 'SlidingPill - Out' }).to(pillElement, { width: 0, duration: frames(18, 50), ease: 'power3.in' }, '<')
  emit('timelineOut', timelineOut)
})
</script>

<template>
  <div ref="pillElement" class="bg-joe-cr-rose-primary text-white h-11 inline-flex items-center rounded-full font-bold text-3xl overflow-hidden whitespace-nowrap">
    <div class="px-4">
      <template v-if="text">{{ text }}</template>
      <slot v-else />
    </div>
  </div>
</template>
